import { SnapshotRenderer } from "oc-threejs/SnapshotRenderer";
import { quatEuler, v3 } from "oc-threejs/short3";
import { ZElement } from "../../arrangement/ZElement";
import { Camera, Group, PerspectiveCamera, Scene } from "three";
import { MAuswahlwert } from "../../../metamodell";
import { UniversalLoader } from "oc-threejs/loader/UniversalLoader";
import { Element3d } from "../../arrangement3d/Element3d";

const imagePromiseCache = new Map();
let _snapshotRenderer = null;

function getSnapshotRendererLazy() {
  if (_snapshotRenderer == null) {
    _snapshotRenderer = new SnapshotRenderer();
  }
  return _snapshotRenderer;
}

export function getRendererCanvas() {
  return getSnapshotRendererLazy().renderer.domElement;
}

export function getVariantUniqueId(element: {
  massAuswahlwert: MAuswahlwert;
  füllungAuswahlwert: MAuswahlwert;
}) {
  return [element.massAuswahlwert.Key, element.füllungAuswahlwert.Key].join("|");
}

async function getPreparedRenderer(
  element: ZElement,
  width: number,
  height: number
): Promise<[SnapshotRenderer, Scene, Camera]> {
  const element3d = (await element.getRenderPromise()) as Element3d;
  await Promise.all([
    element3d.showMasshinweis(),
    new Promise((resolved: any, rejected) =>
      UniversalLoader.delayUntilEverythingLoaded(resolved, "snapshotrenderer", () => {
        console.warn("Timeout in snapshotrenderer");
        rejected();
      })
    ),
    Commons.sleep(100),
  ]);

  element3d.quaternion.copy(quatEuler(0, 0, 0));
  const size = element.getSize();
  element3d.position.x = size.x * -0.5;

  const group = new Group();
  group.name = "ZaunElementList-Element";
  group.add(element3d);

  const snapshotRenderer = getSnapshotRendererLazy();
  const scene = snapshotRenderer.scene.clone();
  const camera = snapshotRenderer.camera.clone();
  scene.add(group);
  snapshotRenderer.render();
  const py = 1;
  camera.position.set(0, py, 2.5);
  camera.lookAt(v3(0, py, 0));
  camera.zoom = width / height; //keep size with image of other dimension
  snapshotRenderer.setSize(width, height);
  // Debugs.checkVisibility(group, snapshotRenderer.camera, snapshotRenderer.scene, snapshotRenderer.renderer);
  return [snapshotRenderer, scene, camera];
}

export async function getBlobDataPromise(zaunElement: ZElement): Promise<Blob> {
  const [width, height] = getMeasures();
  const [r, scene, camera] = await getPreparedRenderer(zaunElement, width, height);
  r.setSize(width, height);
  r.render(scene, camera as PerspectiveCamera);
  return new Promise((resolve) => {
    r.renderer.domElement.toBlob(resolve, "image/png");
  });
}

export function getMeasures() {
  return [200, 200];
}

export function getImageDataPromise(zaunElement: ZElement, variantUniqueId): Promise<string> {
  const [width, height] = getMeasures();
  let imagePromise = imagePromiseCache.get(variantUniqueId);
  if (!imagePromise) {
    imagePromise = getPreparedRenderer(zaunElement, width, height).then(([r, scene, camera]) =>
      r.getAsBackgroundImageForSize(width, height, scene, camera as PerspectiveCamera)
    );
    imagePromiseCache.set(variantUniqueId, imagePromise);
  }
  return imagePromise;
}
